const url = {}
    url.web = 'https://www.madya.ir/api'
    // url.web = 'http://madya.ir:8001'

url.baseURL = url.web
    // url.media = url.web + '/madya_media_cdn'
  url.media = 'http://madya.ir/madya_media_cdn'


export default {
    url,
    locale: 'fa',
    productionTip: true
}



// WEBPACK FOOTER //
// ./src/constans.js